// Простая конфигурация API
const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://test.portal.akmolpro.kz/api/";

export const getAPIURL = () => API_BASE_URL;

// Альтернативный вариант с автоматическим определением окружения
export const getAPIURLAuto = () => {
  // В продакшене используем HTTPS
  if (process.env.NODE_ENV === "production") {
    return "https://test.portal.akmolpro.kz/api/";
  }

  // В разработке используем локальный сервер или переменную окружения
  return process.env.REACT_APP_API_URL || "http://localhost:8502/";
};
